const messages = {
  langname: 'English',
  label: {
    language: 'Language',
    me: 'Me',
    ok: 'OK',
    end: 'End',
    exit: 'Leave',
    cancel: 'Cancel',
    close: 'Dismiss',
    clear: 'Clear',
    error: 'Error',
    filter: 'Filter',
    search: 'Search',
    notfound: 'Nothing found',
    duplicate: 'Duplicate',
    copy: 'Copy',
    paste: 'Paste',
    move: 'Move',
    reorder: 'Reorder',
    new: 'New',
    create: 'Create',
    add: 'Add',
    delete: 'Delete',
    deleteConfirm: 'Confirm Delete',
    trash: 'Trash',
    erase: 'Erase',
    restore: 'Restore',
    hide: 'Hide',
    show: 'Show',
    share: 'Share',
    more: 'More',
    preview: 'Preview',
    settings: 'Settings',
    dashboard: 'Controller',
    edit: 'Edit',
    select: 'Select',
    all: 'All',
    done: 'Done',
    save: 'Save',
    saving: 'Saving...',
    savingError: 'Saving error!',
    send: 'Send',
    files: 'Files',
    download: 'Download',
    off: 'Off',
    on: 'On',
    nolimit: 'No Limit',
    start: 'Start',
    stop: 'Stop',
    resume: 'Resume',
    back: 'Back',
    next: 'Next',
    true: 'True',
    false: 'False',
    schedule: 'Schedule',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds',
    today: 'today',
    yesterday: 'yesterday'
  },
  auth: {
    consent: {
      text: 'By signing in you agree {terms} and {privacy} of {home}',
      terms: 'tems of use',
      privacy: 'privacy policy'
    },
    title: {
      signin: 'Sign In',
      create: 'New account'
    },
    email: {
      label: 'Email'
    },
    password: {
      label: 'Password'
    },
    code: {
      label: 'Code sent to your email'
    }
  },
  account: {
    signout: 'Sign Out',
    id: 'Account ID',
    setup: {
      info: 'Account Setup {step}',
      profile: {
        title: 'Select Start Profile',
        info: 'You can change it later'
      },
      name: {
        title: 'Enter your username',
        info: 'It will be visible to other users'
      }
    },
    switch: {
      attendee: 'Attendee Zone',
      presenter: 'Presenter Zone',
      settings: 'Account Settings',
      add: 'Add Account'
    },
    avatar: {
      add: 'Set Your Picture',
      del: 'Remove Picture'
    },
    name: {
      title: 'Name',
      none: 'No Name'
    },
    email: {
      title: 'Email'
    },
    password: {
      title: 'Password Sign In',
      input: 'New Password'
    },
    menu: {
      title: 'Start Profile',
      ATTENDEE: 'Attendee',
      PRESENTER: 'Presenter'
    },
    delete: {
      input: 'Delete Account',
      confirm: {
        title: 'Do you want to delete your account?',
        subtitle: 'All your data will be lost forever'
      }
    }
  },
  contact: {
    title: 'Contacts',
    empty: 'No Contacts',
    identity: 'Contact ID',
    select: 'Show Selected Groups',
    notfound: 'No Account',
    deleted: 'Account Deleted',
    err: 'Contact ID is already in use',
    groups: {
      btn: 'Groups',
      empty: 'No Groups',
      name: 'Group name',
      err: 'Group with this name already exists',
      delete: 'Deleting group does not delete contacts'
    },
    import: {
      title: 'Import Contacts',
      placeholder: 'Contact ID ; address@email.com ; Group #1 ; Group #2 ; ...',
      btnfile: 'Load CSV file',
      btn: 'Import',
      result: {
        correct: 'Imported',
        found: 'New Contacts',
        groups: 'New Groups',
        notfound: 'No Accounts',
        wrong: 'Skipped',
        duplicates: 'Duplicates',
        errors: 'Errors'
      }
    }
  },
  attendee: {
    guest: {
      label: 'Guest',
      signin: 'Continue As A Guest',
      wronglink: 'Wrong Session Link'
    },
    home: {
      signup: 'Have a Sign Up Code?'
    },
    signup: {
      btn: 'Sign Up',
      code: 'Sign Up Code'
    },
    course : {
      empty: 'No Topics Available'
    },
    topic: {
      retake: 'Retake'
    },
    session: {
      start: 'Start Now',
      notstarted: 'Waiting for the session to start',
      ended: 'Session Ended',
      finish: {
        btn: 'Finish',
        confirm: {
          title: 'Finish Responding?',
          subtitle: 'Once the session is over, you will not be able to go back to processing the answers'
        }
      }
    }
  },
  activity: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    soon: 'Next days',
    sessions: {
      title: 'Scheduled Sessions',
      start: 'Start',
      end: 'End',
      empty: 'No events coming this week'
    },
    posts: {
      title: 'Forum Activity',
      empty: 'No posts for the last 30 days'
    }
  },
  search: {
    person: 'Name, email',
    hint: 'Enter two characters at least',
    noitems: 'Nothing found'
  },
  trash: {
    info: 'Items in trash are kept for 30 days since their delete date',
    noitems: 'The trash is empty',
    empty: 'Empty trash',
    confirmempty: 'Erase all items in trash permanently?',
    confirmitem: 'Erase permanently?'
  },
  item: {
    menu: {
      folder: 'Content',
      course: 'Topics',
      topic: 'Slides',
      team: 'Team',
      attendees: 'Attendees',
      sessions: 'Sessions',
      forum: 'Forum',
      rate: 'Course Rate'
    },
    edit: {
      move: 'Move into',
      copy: 'Duplicate into',
      name: {
        placeholder: 'New Name',
        err: 'Name is required!'
      },
      info: {
        placeholder: 'Drop a line'
      },
      image: {
        select: 'Enter image link or select an image from the folder',
        title: 'Cover'
      },
      files: {
        select: 'Enter file link or select a file from the folder',
        name: 'Name',
        hide: 'Hide From Attendees',
        del: 'Remove attachment?'
      }
    },
    publish: {
      on: 'Share With Attendees',
      off: 'Hide From Attendees'
    },
    home: {
      name: 'Home',
      title: 'Your Projects',
      courses: 'Courses',
      quizzes: 'Quizzes',
      keynotes: 'Keynotes'
    },
    folder: {
      add: 'New Folder',
      name: 'New Folder',
      empty: 'Folder is empty'
    },
    course: {
      add: 'New Course',
      name: 'New Course',
      info: 'Course Info',
      empty: 'No Topics',
      gradebook: {
        settings: 'Gradebook',
        result: 'Result',
        weight: {
          title: 'Assesment Topic Weight'
        },
        retakes: {
          title: 'Assesment Result',
          info: 'In case of multiple attempts take into account',
          first: 'First Result',
          last: 'Last Result',
          avg: 'Average Result',
          max: 'Best Result'
        }
      }
    },
    topic: {
      add: 'New Topic or Keynote',
      name: 'Name',
      info: 'Topic Info',
      empty: 'No Slides'
    },
    quiz: {
      add: 'New Quiz or Task',
      name: 'Name'
    }
  },
  slides: {
    select: {
      title: 'Selection',
      all: 'Select All',
      none: 'Deselect All',
      inverse: 'Invert Selection'
    },
    timer: 'Time Limit',
    group: {
      title: 'Assign to the group',
      off: 'No group',
      merge: 'Merge consecutive group slides into one',
      shuffle: 'Shuffle group with other slides and groups',
      count: 'Shuffled slides limit in the group'
    },
    add: {
      btn: 'Add Slide or Question',
      keynote: 'Presentation Elements',
      quiz: 'Quiz Questions',
      poll: 'Poll Questions',
      clipboard: 'Paste From Clipboard',
      pasteall: 'Paste All',
      slide: 'Slide',
      image: 'Link/File',
      movie: 'Movie',
      choice: 'Choice',
      yesno: 'True/False',
      order: 'Order',
      number: 'Number',
      gaps: 'Fill Gaps',
      essay: 'Essay',
      vote: 'Vote',
      rate: 'Rate',
      open: 'Open'
    },
    edit: {
      copy: 'Copied to clipboard',
      delete: 'By deleting the slide, you will lose access to session participants data associated with this slide. This operation cannot be undone.',
      notes: 'Speaker notes',
      image: {
        url: 'Enter a link or select a file from the folder',
        supported: ''
      },
      movie: {
        url: 'Movie URL (YouTube or Vimeo)'
      },
      choice: {
        correct: 'Point Out Correct Answers',
        multi: 'Multiple Choice Question',
        tails: {
          title: 'Display Answers As Tails',
          sm: 'Small Tails',
          md: 'Middle Tails',
          lg: 'Large Tails'
        }
      },
      yesno: {
        correct: 'Point Out Positive Statements',
        label: {
          positive: 'Positive Label',
          negative: 'Negative Label'
        }
      },
      order: {
        correct: 'Specify the first irrelevant answer (if any)',
        info1: 'Answers are always randomized for this type of question'
      },
      number: {
        correct: 'Enter the correct answer'
      },
      gaps: {
        correct: 'Write the text with gaps definitions',
        dropdown: {
          title: 'Suggest Possible Responses',
          info: 'A dropdown list will be displayed in the answer box with all the correct answers defined in the gaps. Responses will be displayed in alphabetical order.'
        },
        selects: {
          title: 'Each gap has its own suggestions',
          info: 'A dropdown list will be displayed in the answer box with all the answers defined in the gap. Responses will be displayed in alphabetical order. Only the first defined answer is considered correct.'
        },
        case: 'Check Case Sensitive',
        diacritics: 'Ignore Diacritics',
        info1: 'Where you want a gap to be created in a sentence, put the correct answer in double square brackets. If more than one correct answer is possible, separate each option with a forward slash. To specify an empty answer as correct, use a minus sign (participants should also use a minus sign to give an empty answer). See the example below:',
        example1: 'Where [[is]] hot, there [[are/live]] giraffes and [[-]] elephants.',
        info2: 'Warning! Changing the order of the defined gaps in the text will result in an incorrect matching of the answers collected so far. The safe form of modifying a question is one that does not change the order of the existing gaps or adds new gaps after existing ones.'
      },
      essay: {
        textinfo: 'The field for giving an open answer will be hidden',
        fileinfo: 'The field for attaching a file will be hidden'
      },
      vote: {
        multi: 'Multiple Choice Question',
        multimax: 'Maximum allowed selections'
      },
      rate: {
        option: 'Rate Variant',
        stars5: 'Stars 1 - 5',
        scale1to10: 'Scale 1 - 10',
        scale0to10: 'Scale 0 - 10',
        slider100: 'Slider 0 - 100',
        label: {
          min: 'min. label',
          max: 'max. label'
        }
      },
      open: {
        textlimit: 'Response Characters Limit',
        filelimit: 'File Size Limit [MB]'
      },
      params: {
        x: 'Question Parameters',
        y: 'Correct Answers',
        add: 'New random set',
        delete: {
          all: 'Removal of random parameters results in the withdrawal of points awarded to all participants for this question. This operation cannot be undone.',
          row: 'Deleting a random set results in the withdrawal of the points awarded for this question to those participants who drew the set. This operation cannot be undone.'
        },
        use: 'Random Parameters'
      },
      answers: {
        add: {
          answer: 'New Answer',
          statement: 'New Statement'
        },
        delete: 'By deleting an answer, you will lose session participant data associated with that answer. This operation cannot be undone.',
        enter: 'ENTER Adds New Answer',
        ctrlenter: 'CTRL/CMD + ENTER Adds New Answer',
        multi: 'Adds Each Line As Seperate Answer',
        randomize: {
          on: 'Randomize answers',
          off: 'Do not randomize answers',
          lastoff: 'Do not randomize last answer'
        }
      },
      points: {
        all: {
          correct: 'Points for correct response',
          wrong: 'Points for wrong response'
        },
        each: {
          correct: 'Points for each correct response',
          wrong: 'Points for each wrong response'
        },
        toggle: 'Count points for each answer'
      }
    }
  },
  team: {
    owner: 'Owner',
    empty: 'No Team Member',
    add: 'Add Team Member',
    role: {
      title: 'Set Team Role',
      PRESENTER: 'Presenter',
      EDITOR: 'Coordinator',
      ADMIN: 'Administrator'
    }
  },
  attendees: {
    empty: 'No Attendee',
    emptyinfo: 'Give participants the sign-up code or click the plus button to search and add participants or create a group',
    add: 'Add Attendee',
    block: {
      on: 'Block Attendee?',
      off: 'Unblock Attendee?'
    },
    code: {
      show: 'Signup Code',
      copy: 'Copy code',
      link: 'Copy link',
      qr: 'Download qr-code',
      renew: 'Generate New'
    },
    groups: {
      all: 'All',
      not: 'Without Group',
      edit: {
        add: 'Create Group',
        placeholder: 'Group Name',
        err: 'Name is required!'
      },
      change: 'Change Group'
    },
    result: {
      show: {
        all: 'Show All',
        errors: 'Show Errors'
      }
    }
  },
  sessions: {
    empty: 'No Sessions',
    notstarted: 'No Start Time',
    add: {
      title: 'Create New Sesssion',
      private: 'Private Session (signup code required)',
      all: 'Open Session (All Attendees)',
      group: 'Group Session ({name})'
    },
    manager: {
      action: {
        leave: 'Leave Session',
        end: 'End Session',
        start: 'Session Start',
        stop: 'Session End',
        slides: 'Keynote',
        projector: 'Projector Setup',
        results: 'Show Results (LIVE)',
        check: 'Check Response'
      },
      confirm: {
        start: 'Start Session Now?',
        startError: 'Start Date From Past!',
        stop: 'End Session Now?',
        stopError: 'End Date Before Start Date!'
      },
      chat: {
        inputOff: 'Chat Off'
      },
      settings: {
        show: {
          code: 'Display Signup Code',
          leader: 'Display Leader Board'
        },
        forward: {
          title: 'Question After Question Navigation',
          info: 'Always navigate to the next question, no return.'
        },
        result: {
          title: 'Show result summary',
          info: 'Show the answer time and number of points scored after completing the answer.'
        },
        feedback: {
          title: 'Show corect responses and poll results',
          info: 'Show correct solutions and survey results for individual questions after completing the answer.'
        },
        share: {
          title: 'Share Slides',
          info: 'After the session ends, the participants will have access to the content of the slides.'
        },
        time: {
          title: 'Time Limit',
          info: 'The maximum time for response from the start of the quiz.'
        },
        retakes: {
          title: 'Retakes',
          info: 'Number of attempts allowed to take the quiz (after the first take).'
        }
      }
    }
  },
  messenger: {
    title: 'Messenger',
    empty: 'No Messages',
    input: 'New message',
    btn: 'Keybord: CTRL/CMD + ENTER'
  },
  forum: {
    empty: 'No Topics',
    posts: 'Posts: {total}',
    last: 'Last: {date}',
    trash: 'Deleted Topics',
    deleted: 'Deleted: {date}',
    edit: {
      name: 'Topic Name',
      info: 'Topic Description',
      readonly: 'Attendees can only read',
      reverse: 'Most recent posts at top',
      groups: 'Limit access to the selected group attendees',
      nogroups: 'No Groups'
    },
    post: {
      empty: 'No Posts',
      add: 'New Post',
      edit: 'Post Edit',
      edited: 'Edit: {date}',
      hidden: 'Post hidden by the forum moderator'
    }
  },
  rate: {}
}

const numberFormats = {
  currency: {
    style: 'currency',
    currency: 'USD'
  }
}

const dateTimeFormats = {
  short: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  normal: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric'
  }
}

import quasar from 'quasar/lang/en-us'

export default {
  quasar,
  messages,
  numberFormats,
  dateTimeFormats
}
